export default __webpack_public_path__ + "static/media/banco-popular.9ec09088.svg";